/* -----------------UI--------------- */
import Box from "@memorang/ui/src/components/Box";

import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useLocalSearchParams } from "expo-router";

/* -----------------Child components--------------- */
import { ProductsList } from "@features/dashboard/components/Store/ProductsList";
import type { Section } from "@features/dashboard/components/Store/ProductsList";

import { pageViewTypes } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import type { ExamDetails } from "@memorang/types/src/exams";
import { TextSkeleton } from "@memorang/ui/src/components/ChatUI/TextSkeleton";

type Props = {
	handleNext: (step: string) => void;
	groupedExams: Section[];
};
export const ChooseExamContainer = ({ handleNext, groupedExams }: Props) => {
	const { param: selectedCategory } = useLocalSearchParams<{
		param: string;
		showBackButton: string;
	}>();

	const { handleSwitchExamContext } = useExamContext();

	useAnalytics({
		type: pageViewTypes.chooseExam,
		selectedCategory,
	});

	if (!groupedExams.length) {
		return (
			<Box flex={1} paddingTop={24} gap={16}>
				{Array.from({ length: 7 }).map((_, i) => (
					<Box
						// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						key={i}
						flexDirection="row"
						gap={8}
						alignItems="center"
						height={44}
						padding={18}
					>
						<Box flex={1}>
							<TextSkeleton height={24} />
						</Box>
						<Box width={34}>
							<TextSkeleton height={24} />
						</Box>
					</Box>
				))}
			</Box>
		);
	}

	const filteredExams = groupedExams.filter((exam) => {
		return selectedCategory
			? exam.title.toLocaleLowerCase() === selectedCategory?.toLocaleLowerCase()
			: true;
	});

	const interceptHandleSwitchExamContext = async (examDetails: ExamDetails) => {
		await handleSwitchExamContext(examDetails);
		handleNext("userdetails");
	};

	return (
		<ProductsList
			products={filteredExams}
			showProducts={false}
			showChevronRight
			handleSwitchExamContext={interceptHandleSwitchExamContext}
		/>
	);
};
